import { EditAliasRow } from '../common';
import { IntegrationFragment } from '@stigg-types/apiTypes';

export type ZuoraIntegrationDetailsProps = { integration: IntegrationFragment };

export function ZuoraIntegrationDetails({ integration }: ZuoraIntegrationDetailsProps) {
  return <EditAliasRow integration={integration} />;
}
